import React, { useState, useEffect } from "react";
import axios from "axios";
import "../../assets/Css/ActionView.css";
import Outlet from "../Outlet";
import { FiEdit2 } from "react-icons/fi";
import { CiSearch } from "react-icons/ci";
import Breadcrumb from "../Breadcrumb";
import { useLocation, useNavigate } from "react-router-dom";

const ActionView = () => {
  const [products, setProducts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [productsPerPage, setProductsPerPage] = useState(10);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedRange, setSelectedRange] = useState("Last 6 Months");
  const [selectedRow, setSelectedRow] = useState(null);
  const [totalPages, setTotalPages] = useState(1); // ✅ Add this

  const location = useLocation();
  const data = location.state || {};
  const user = data.user;

  const navigate = useNavigate();

  // fetch products when page ya limit change thay
  useEffect(() => {
    if (!user) return;
    fetchProducts();
  }, [user, currentPage, productsPerPage]); // ✅ dependency add kari

  const fetchProducts = async () => {
    try {
      const res = await axios.get(
        `https://network.rentel.in/admin/users/${user._id}/products?page=${currentPage}&limit=${productsPerPage}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
          },
        }
      );

      setProducts(res.data.products || []);
      setTotalPages(res.data.totalPages || 1); // ✅ backend thi totalPages
    } catch (err) {
      console.error("Error fetching user products:", err);
    }
  };

  const handleViewClick = (product) => {
    navigate(`/ProductDetails`, { state: { product } });
  };

  const deleteProduct = async (productId, hard = false) => {
    try {
      const token = localStorage.getItem("adminToken");
      const url = `https://network.rentel.in/admin/products/${productId}?hard=${hard}`;

      const response = await axios.delete(url, {
        headers: { Authorization: `Bearer ${token}` },
      });

      return response.data;
    } catch (error) {
      console.error("Error deleting product:", error.response?.data || error.message);
      throw error;
    }
  };

  return (
    <Outlet>
      <div className="dashboard-headera">
        <div className="dashboard-title">
          <h2 className="dashboard-title">Dashboard</h2>
          <select
            className="dashboard-filter"
            value={selectedRange}
            onChange={(e) => setSelectedRange(e.target.value)}
          >
            <option>Last 6 Months</option>
            <option>Last Month</option>
            <option>Last Week</option>
            <option>Today</option>
          </select>
        </div>
        <Breadcrumb />
      </div>

      {/* Table Section */}
      <div className="table-container">
        <div className="table-header">
          <h3>User Product List</h3>
          <div className="search-bar">
            <CiSearch />
            <input type="text" placeholder="Search product..." />
          </div>
        </div>

        <table className="product-table">
          <thead>
            <tr>
              <th>No</th>
              <th>Product</th>
              <th>Buy price</th>
              <th>Items</th>
              <th>Category</th>
              <th>Listing date</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {products.map((p, index) => (
              <tr key={p._id}>
                <td>{(currentPage - 1) * productsPerPage + index + 1}</td>
                <td className="product-cell">
                  <img src={p.images} alt={p.title} className="product-img" /> {p.title}
                </td>
                <td>₹{p.price}</td>
                <td>01</td>
                <td>{p.category}</td>
                <td>{p.createdAt ? new Date(p.createdAt).toLocaleDateString() : "N/A"}</td>
                <td>
                  <button className="view-btn" onClick={() => handleViewClick(p)}>View</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Pagination */}
        <div className="pagination-container">
          <div>
            Showing{" "}
            <select
              value={productsPerPage}
              onChange={(e) => {
                setCurrentPage(1);
                setProductsPerPage(Number(e.target.value));
                setSelectedRows([]);
              }}
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={20}>20</option>
            </select>{" "}
            of {totalPages * productsPerPage}
          </div>

          <div className="pagination">
            <button
              onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
              disabled={currentPage === 1}
            >
              {"<"}
            </button>
            {[...Array(totalPages)].map((_, i) => (
              <button
                key={i}
                className={currentPage === i + 1 ? "active" : ""}
                onClick={() => setCurrentPage(i + 1)}
              >
                {i + 1}
              </button>
            ))}
            <button
              onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
              disabled={currentPage === totalPages}
            >
              {">"}
            </button>
          </div>
        </div>
      </div>
    </Outlet>
  );
};

export default ActionView;
